<template>
  <div class="animated fadeIn">
    <div class="row pageinfo">
      <b-col lg="6">
        <h2>Notifications</h2>
      </b-col>
    </div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <b-container fluid>
            <b-row class="justify-content-between">
              <b-col md="4" class="my-1">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <b-form-input v-model="filter" placeholder="Search" />
                    <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                  </div>
                </div>
              </b-col>
              <b-col>
                <b-form-checkbox class="pull-right"
                  id="checkbox"
                  @click.native.stop
                  @change="checkedField()"
                  :checked="notifications"
                >&nbsp; Notifications</b-form-checkbox>
              </b-col>
            </b-row>

            <b-row v-if="loadingData">
              <b-col cols="12" sm="12" md="12" lg="12">
                <p class="text-center">
                  <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i>
                  <br />Loading data...
                </p>
              </b-col>
            </b-row>
            <!-- End Main table Elements-->
            <b-table
              class="animated fadeIn"
              striped
              hover
              v-else
              bordered
              show-empty
              :fixed="false"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @filtered="onFiltered"
            >
              <template slot="select" slot-scope="row">
                <b-form-checkbox
                  id="checkbox"
                  @click.native.stop
                  @change="checkedField(row)"
                  :checked="row.item.active"
                  :disabled="check"
                ></b-form-checkbox>
              </template>
            </b-table>
            <b-row>
              <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
                <div class="input-group mb-3">
                  <div class="input-group-prepend"></div>
                  <b-select :options="pageOptions" v-model="perPage" />
                </div>
              </b-col>
              <!-- User Interface controls -->
              <b-col lg="10" md="10" sm="12" class="my-1">
                <b-pagination
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0 pull-right"
                />
              </b-col>
            </b-row>
            <!-- End User Interface controls-->
          </b-container>
        </b-row>
      </div>
    </div>
    <!-- New  Modal-->
    <b-modal
      title="New Fluid Types"
      v-model="newFluidTypes"
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-row>
        <b-col cols="12">
          <b-form-group
            label="Fluid Type Name"
            label-for="FluidTypeName"
            :label-cols="4"
            horizontal
          >
            <b-form-input type="text" v-model="FluidTypesName" class="form-control" />
          </b-form-group>
          <b-form-group
            label="Isolera Fluid Type Name"
            label-for="isolera_fluid_type_name"
            :label-cols="4"
            horizontal
          >
            <b-form-input type="text" v-model="isolera_fluid_type_name" class="form-control" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group
            label="Fluid Type Color"
            label-for="FluidTypeColor"
            :label-cols="4"
            horizontal
          >
            <b-form-input type="color" v-model="FluidTypesColor" class="form-control" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <!-- End New Modal-->
  </div>
</template>

<script>
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import notification_services from "./notification_services";
import services_service from "../services/services_service";

Vue.use(VueSweetalert2);

const items = [];
export default {
  name: "m_fluid_types",
  created: function() {
    this.getAll();
    localStorage.removeItem("tagetsaPage");
    localStorage.removeItem("targetPage");
    localStorage.removeItem("taPage");
    localStorage.removeItem("tpPage");
    localStorage.removeItem("oasaPage");
    localStorage.removeItem("oaPage");
    localStorage.removeItem("reportPage");
    localStorage.removeItem("rolesPage");
    localStorage.removeItem("servicePage");
    localStorage.removeItem("tasaPage");
    localStorage.removeItem("tcPage");
    localStorage.removeItem("locationPage");
    localStorage.removeItem("truckPage");
    localStorage.removeItem("userPage");
    if (!localStorage.ftPage) {
      localStorage.ftPage = 0;
    }
  },
  data() {
    return {
      check: false,
      trash: false,
      notifications: null,
      dpdt: "Active",
      FluidTypesName: "",
      isolera_fluid_type_name: "",
      FluidTypesColor: "#ffff00",
      loadingData: true,
      FluidTypesId: null,
      newFluidTypes: false,
      items: items,
      fields: [
        {
          key: "select",
          label: "",
          thClass: 'select_column', tdClass: 'select_column'
        },
        {
          key: "id",
          label: "ID",
          sortable: true,
          thClass: 'id_column', tdClass: 'id_column'
        },
        {
          key: "fluid",
          label: "Fluid Type Name",
          sortable: true
        }
      ],
      currentPage: parseInt(localStorage.ftPage),
      perPage: 25,
      totalRows: items.length,
      pageOptions: [25, 50, 100],
      sortBy: null,
      sortDesc: false,
      filter: null,
      selectedItems: ["id", "name"],
      configTable: false,
      modalInfo: {
        title: "",
        content: ""
      },
      modalEdit: {
        title: ""
      },
      savebtn: true
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          };
        });
    }
  },
  methods: {
    checkedField(row = null) {
      if (row) {
        this.check = true;
        let new_items = this.items.map(value => {
          return {
            id: value.id,
            fluid: value.fluid,
            active: value.id === row.item.id ? !row.item.active : value.active
          };
        });
        let notifications = {
          notification: this.notifications,
          fluid_types: new_items
        };
        console.log("notifications", notifications);
        notification_services
          .putConfig(notifications)
          .then(data => {
            if (data.status == "success") {
              this.getAll();
              this.$swal(data.status, data.message, data.status);
            } else {
              // console.log('status', data)
              this.$swal(data.status, data.message, data.status);
              this.loadingData = false;
              // this.getAll()
              return;
            }
            this.check = false;
            this.loadingData = false;
          })
          .catch(error => {
            Vue.swal("Error", "Server not response. " + error, "error");
            this.loadingData = false;
          });
      } else {
        let notifications = {
          notification: !this.notifications,
          fluid_types: this.items
        };
        notification_services
          .putConfig(notifications)
          .then(data => {
            if (data.status == "success") {
              this.getAll();
              this.$swal(data.status, data.message, data.status);
            } else {
              // console.log('status', data)
              this.$swal(data.status, data.message, data.status);
              this.loadingData = false;
              // this.getAll()
              return;
            }
            this.check = false;
            this.loadingData = false;
          })
          .catch(error => {
            Vue.swal("Error", "Server not response. " + error, "error");
            this.loadingData = false;
          });
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.currentPage = parseInt(localStorage.ftPage);
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getAll() {
      this.items = null;
      this.loadingData = true;
      notification_services
        .getAll()
        .then(data => {
          if (data.status == "success") {
            this.items = data.configs.notifications.fluid_types;
            this.notifications = data.configs.notifications.notification;
          } else {
            this.$swal(data.status, data.message, data.status);
            this.loadingData = false;
            // this.getAll()
            return;
          }
          this.loadingData = false;
        })
        .catch(error => {
          Vue.swal("Error", "Server not response. " + error, "error");
          this.loadingData = false;
        });
    },
    restoreFT(id) {
      this.$swal({
        title: "Please Confirm!",
        text: "Are you sure to restore this Fluid Type?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, restore it!"
      }).then(result => {
        if (result.value) {
          notification_services
            .restore(id)
            .then(data => {
              this.$swal(data[0], data[1], data[0]);
              if (data[0] == "success") {
                this.filter = "";
                this.trash = false;
                this.getAll();
                this.loadingData = true;
              }
            })
            .catch(error => {
              this.$swal("Error", "Server not response. " + error, "error");
            });
        }
      });
    }
  }
};
</script>
<style scoped>
/deep/ .custom-control-input {
  position: relative !important;
}
/deep/ .custom-control {
  padding-top: 2px !important;
  margin: 0 !important;
}
/deep/ .select_column{width: 4%}
/deep/ .id_column{width: 8%}
</style>



// WEBPACK FOOTER //
// src/views/notification/notifications.vue